import { Component, Input } from "@angular/core";
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from "@techiediaries/ngx-qrcode";

@Component({
  selector: "app-point-qr-code",
  templateUrl: "./point-qr-code.component.html"
})
export class PointQrCodeComponent {

  @Input() elementType = NgxQrcodeElementTypes.IMG;
  @Input() errorCorrectionLevel = NgxQrcodeErrorCorrectionLevels.LOW;

  @Input() margin = 0;
  @Input() width: number = undefined;
  @Input() scale: number = 5.5; // default is 4
  @Input() cssClass: string = 'qrcode';

  pointId: string;
  pointIdUrl: string;

  @Input("pointId")
  public set pointIdSetter(pointId: string) {
    this.pointId = pointId;
    this.pointIdUrl = this.urlForPointId();
  }

  private urlForPointId(): string {
    //TODO: actual production url prefix
    const prefix = "FES:"; //"http://localhost:4200/#/home?itemType=point&itemId=";
    return prefix + encodeURIComponent(this.pointId);
  }
}
